import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const TimprisElavtal = lazy(() => import("@/pages/elavtal/Timpris"));

export const Route = createFileRoute("/elavtal/timpris")({
  head: () => seoHead("/elavtal/timpris", { description: "Timpris innebär att din elkostnad varierar varje timme efter spotpriset. Perfekt för dig som kan flytta förbrukning till billiga timmar." }),
  component: () => <TimprisElavtal />,
});
